// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-comments-responses--title{align-items:center;font-weight:400;font-size:12px;justify-content:space-between}.w-comments-responses--main .v-card__text{padding:0}", ""]);
// Exports
module.exports = exports;
